import {selectFinalRound, selectRound} from "../redux/reducers/sharedStateReducer/selectors";

/**
 * Последний раунд партии и правила, которые к нему привязаны: запрет найма
 * новых отрядов, автопропуск этапа найма, предупреждение в предпоследнем.
 *
 * Число раундов у каждой партии свое — gameState.finalRound, а не общий
 * FINAL_ROUND из конфига: локальную партию настраивают на экране игроков, у
 * миссий кампании и глав обучения оно свое, досрочный конец матча его
 * переписывает. Тот же лимит проверяет и редьюсер конца раунда.
 */

/**
 * Лимит раундов партии или null, если раунды не ограничены: миссия с
 * finalRound: null («раундов не ограничиваем») — последнего раунда нет вовсе
 */
export const getRoundLimit = (finalRound) => (
  Number.isInteger(finalRound) && finalRound > 0 ? finalRound : null
);

export const checkIfFinalRoundOf = (round, finalRound) => {
  const roundLimit = getRoundLimit(finalRound);
  return roundLimit !== null && round === roundLimit;
};

// Предпоследний раунд: последний, в котором еще можно нанимать новые отряды
export const checkIfPreFinalRoundOf = (round, finalRound) => {
  const roundLimit = getRoundLimit(finalRound);
  return roundLimit !== null && round === roundLimit - 1;
};

// По redux-состоянию, а не по номеру раунда: лимит раундов у партии свой, и
// передать его забыть нельзя
export const checkIfFinalRound = (state) => (
  checkIfFinalRoundOf(selectRound(state), selectFinalRound(state))
);

export const checkIfPreFinalRound = (state) => (
  checkIfPreFinalRoundOf(selectRound(state), selectFinalRound(state))
);
